import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f5aff1e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6f5aff1e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-15.10.2.tgz_cache-loader@4._xbc2zsunuyw4mnfmppd25q2opq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports